<script>
import { Table, TableColumn, Tooltip } from "element-ui";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";

export default {
  name: "CompanyBrandingIndex",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Tooltip.name]: Tooltip,
  },
  data() {
    return {
      loading: false,
      rows: [],
      meta: { current_page: 1, last_page: 1, total: 0 },
      search: "",
    };
  },
  created() {
    this.fetchData();
  },
  methods: {

  changeStatus(index, row) {
    const prev_val = !!row.is_active;            // current boolean
    const next_val = prev_val ? 0 : 1;           // target numeric for API

    Swal.fire({
      title: "Are you sure?",
      text: "You want to change status!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn",
      cancelButtonClass: "btn greybtn",
      confirmButtonColor: "#E0E0E0",
      cancelButtonColor: "",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    })
      .then(async (result) => {
        if (result.value) {
          this.loading = true;
          try {
            const fd = new FormData();
            fd.append("is_active", next_val);
            await this.$http.post(`branding/${row.id}`, fd);

            // success toast + optional refresh
            Swal.fire({
              title: "Success!",
              text: "Status has been Changed.",
              icon: "success",
              confirmButtonClass: "btn btn-success",
            });
            // If you want to re-sync from server:
            // this.fetchData(this.meta.current_page);
          } catch (e) {
            // revert UI on error
            row.is_active = prev_val;
            Swal.fire("Error", "Failed to update status.", "error");
          } finally {
            this.loading = false;
          }
        } else {
          // revert on cancel
          row.is_active = prev_val;
        }
      })
      .catch(() => {
        row.is_active = prev_val;
      });
  },
    async fetchData(page = 1) {
      this.loading = true;
      try {
        const { data } = await this.$http.get("branding", {
          params: { page, search: this.search || undefined },
        });
        this.rows = data.data || [];
        this.meta = data.meta || { current_page: 1, last_page: 1, total: 0 };
      } catch (e) {
        Swal.fire("Error", "Failed to load companies.", "error");
      } finally {
        this.loading = false;
      }
    },
    go(page) {
      if (page < 1 || page > this.meta.last_page) return;
      this.fetchData(page);
    },
    copy(link) {
      navigator.clipboard?.writeText(link);
      Swal.fire("Copied", "Shareable link copied to clipboard.", "success");
    },
    createNew() {
      this.$router.push({ name: "BrandingCreate" });
    },
    editRow(row) {
      this.$router.push({ name: "BrandingEdit", params: { id: row.id } });
    },
    async toggleStatus(row) {
      const next = !row.is_active;
      const res = await Swal.fire({
        title: "Change Status?",
        text: `Set "${row.company_name}" to ${next ? "Active" : "Inactive"}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
      });
      if (!res.isConfirmed) return;

      this.loading = true;
      try {
        const fd = new FormData();
        fd.append("is_active", next ? 1 : 0);
        await this.$http.post(`branding/${row.id}`, fd);
        Swal.fire("Success", "Status updated.", "success");
        this.fetchData(this.meta.current_page);
      } catch (e) {
        Swal.fire("Error", "Failed to update status.", "error");
      } finally {
        this.loading = false;
      }
    },
    async deleteRow(row) {
      const res = await Swal.fire({
        title: "Delete Company?",
        text: `This will remove ${row.company_name} branding.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Delete",
      });
      if (!res.isConfirmed) return;

      this.loading = true;
      try {
        await this.$http.delete(`branding/${row.id}`);
        Swal.fire("Deleted", "Company removed.", "success");
        const nextPage =
          this.rows.length === 1 && this.meta.current_page > 1
            ? this.meta.current_page - 1
            : this.meta.current_page;
        this.fetchData(nextPage);
      } catch (e) {
        Swal.fire("Error", "Failed to delete.", "error");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<template>
  <div class="content" v-loading.fullscreen.lock="loading">
    <base-header class="pb-6">
      <div class="row align-items-center py-2">
        <!-- <div class="col-lg-6 col-12">
          <h2 class="mb-0">Companies</h2>
        </div> -->
        <div class="col-lg-6 col-12 text-right">

        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <card class="no-border-card" footer-classes="pb-2">
        <template slot="header">
          <div class="row align-items-center">
            <div class="col-lg-6 col-md-6 col-12">
              <h2 class="mb-0">Branding List</h2>
            </div>
            <div class="col-lg-6 col-md-6 text-right">
              <base-button class="btn btn-primary" type="primary" @click.native="createNew">
            <i class="fa fa-plus" aria-hidden="true"></i> Create New Company
          </base-button>
            </div>
          </div>
        </template>
           <div class="row flex-wrap">
              <div class="col-md-6 search-style mb-2">
                <base-input label="Search:" placeholder="Search..." prepend-icon="fas fa-search"
                  v-model="search"
                  @keyup.enter="fetchData(1)"
                ></base-input>
              </div>
              </div>
        <div class="user-eltable">
          <el-table
            :data="rows"
            class="compGrid"
            header-row-class-name="thead-light"
            highlight-current-row
            id="tbl-branding"
            role="table"
            row-key="id"
            stripe
          >
            <el-table-column label="Company Name" min-width="220" prop="company_name">
              <template slot-scope="props">
                <span>{{ props.row.company_name }}</span>
              </template>
            </el-table-column>

            <el-table-column label="Slug" min-width="180" prop="slug">
              <template slot-scope="props">
                <code>{{ props.row.slug }}</code>
              </template>
            </el-table-column>

            <el-table-column label="Logo" min-width="120">
              <template slot-scope="{ row }">
                <img v-if="row.logo_url" :src="row.logo_url" alt="" style="height:32px;object-fit:contain" />
                <span v-else class="text-muted">—</span>
              </template>
            </el-table-column>

          <el-table-column label="Status" prop="is_active" min-width="120">
            <template slot-scope="props">
              <div class="d-flex active-status" v-on:click="changeStatus(props.$index, props.row)">
                <base-switch
                  class="mr-1"
                  type="success"
                  v-if="props.row.is_active"
                  v-model="props.row.is_active">
                </base-switch>
                <base-switch
                  class="mr-1"
                  type="danger"
                  v-else
                  v-model="props.row.is_active">
                </base-switch>
              </div>
            </template>
          </el-table-column>

        <el-table-column label="Generated Link" min-width="260">
          <template slot-scope="{ row }">
            <small style="cursor: pointer;">
              <div class="generated-link text-sm" @click.stop="copy(row.share_url)" title="Click to copy">
                {{ row.share_url }}
              </div>
            </small>
          </template>
        </el-table-column>



         <el-table-column align="right" label="Actions" min-width="120px">
          <div class="actions-container" slot-scope="{ row }">
            <!-- Edit Button -->
            <el-tooltip content="Edit" placement="top">
              <base-button
                @click.native="editRow(row)"
                class="success btn base-button success btn-icon btn-fab btn-sm action-btn"
                data-original-title="Edit"
                data-toggle="tooltip"
                icon
                size="sm"
                type=""
              >
                <img
                  class="ico-edit action-icon"
                  src="/img/icons/common/edit.svg"
                  alt="Edit"
                  style="max-width: 16px; max-height: 16px;"
                />
              </base-button>
            </el-tooltip>

            <!-- Delete Button -->
            <el-tooltip content="Delete" placement="top">
              <base-button
                @click.native="deleteRow(row)"
                type=""
                class="action-btn"
                size="sm"
                icon
                data-toggle="tooltip"
                data-original-title="Delete"
              >
                <img
                  class="ico-del action-icon"
                  src="/img/icons/common/delete-icon.svg"
                  alt="Delete"
                  style="max-width: 16px; max-height: 16px;"
                />
              </base-button>
            </el-tooltip>

              <el-tooltip content="Copy" placement="top">
                      <base-button
                        @click.native="copy(row.share_url)"
                        class="delete action-btn"
                        type=""
                        size="sm"
                        icon
                        data-toggle="tooltip"
                        data-original-title="Delete"
                      >
                      <img class="ico-assign-course action-icon" src="/img/icons/common/assing_course.svg" width="18" alt="" />

                        <!-- <i class="text-danger  far fa-copy"></i> -->
                      </base-button>
                    </el-tooltip>
          </div>
        </el-table-column>

          </el-table>
        </div>

        <template slot="footer">
          <div class="d-flex justify-content-between align-items-center">
            <div class="text-muted small">
              Page {{ meta.current_page }} of {{ meta.last_page }} — Total {{ meta.total }}
            </div>
            <div class="d-flex gap-2">
              <base-button class="btn btn-light" :disabled="meta.current_page<=1" @click.native="go(meta.current_page-1)">
                Prev
              </base-button>
              <base-button class="btn btn-light" :disabled="meta.current_page>=meta.last_page" @click.native="go(meta.current_page+1)">
                Next
              </base-button>
            </div>
          </div>
        </template>
      </card>
    </div>
  </div>
</template>

<style scoped>
.custom-size .action-icon { height: 18px; width: 18px; }
</style>
